import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalContext";

const Watchlist = () => {
  const { watchlist, removeFromWatchlist } = useContext(GlobalContext);

  return (
    <div className="container">
      <h1>🎞️ Your Watchlist</h1>

      {watchlist.length === 0 ? (
        <p>Your watchlist is empty. Go add some movies!</p>
      ) : (
        <div className="movie-grid">
          {watchlist.map((movie) => (
            <div key={movie.id} className="movie-card">
              <img
                src={
                  movie.poster_path
                    ? `https://image.tmdb.org/t/p/w300${movie.poster_path}`
                    : "https://via.placeholder.com/300x450?text=No+Image"
                }
                alt={movie.title}
              />
              <h4>{movie.title}</h4>
              <p>{movie.release_date}</p>
              <button onClick={() => removeFromWatchlist(movie.id)}>
                ❌ Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Watchlist;
